import { call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import { pathsMatchSelector } from '../../../selectors';
import Paths from '../../../constants/Paths';

export function* goToLoginService() {
  yield put(push(Paths.LOGIN));
}

export function* goToRootService() {
  yield put(push(Paths.ROOT));
}

export function* locationChangedService() {
  const pathsMatch = yield select(pathsMatchSelector);

  if (!pathsMatch) {
    return;
  }

  switch (pathsMatch.path) {
    case Paths.ROOT:
    case Paths.FACTORIES:
    case Paths.SITES:
    case Paths.DASHBOARD:
    case Paths.DEVICES:
    case Paths.BRANDS:
    case Paths.LIST_DEVICES:
    case Paths.LIST_SITES:
    case Paths.LIST_MODELS:
    case Paths.LIST_PROTOCOLS:
    case Paths.LIST_CHANNELS:
    case Paths.LIST_ITEMS:
    case Paths.LIST_ALERTS_SETTING:
    case Paths.LIST_ALERTS:
    case Paths.DIAGRAM:
    case Paths.CHARTS:
    case Paths.CHARTS_COMPARE:
    case Paths.REPORTS:
    case Paths.TRENDS:
    case Paths.SETTING_GENERAL:
    case Paths.SETTING_INVOICES:
    case Paths.SETTING_USER:
    case Paths.SETTING_PRICES:
    case Paths.SETTING_EMAILS:
    case Paths.SETTING_ALARM:
    case Paths.SETTING_DASHBOARD:
    case Paths.REPORT_DEVICE:
    case Paths.REBOOT_SYSTEM:
    case Paths.ARCHITECTURE:
      yield call(goToLoginService);

      break;
    default:
  }
}
